export default __webpack_public_path__ + "static/tom-field-07894f0af5b6d4ef07e5ffd4cb51855a.png";